/* eslint-disable no-nested-ternary */
import type { IIndicatorFieldsFragment } from "components/financials/modern/graphql/fragments/__generated__/IndicatorFieldsFragment.generated";
import translateIndicatorCategory from "components/financials/translateIndicatorCategory";
import classNames from "components/ui/classNames";
import useTheme from "components/ui/useTheme";
import { useIntl } from "react-intl";
import tinycolor from "tinycolor2";

interface IndicatorCategoryTagProps {
  variant?: "outline" | "normal";
  indicator: Pick<IIndicatorFieldsFragment, "columnTheme" | "category">;
}
export default function IndicatorCategoryTag({ variant = "normal", indicator }: IndicatorCategoryTagProps) {
  const intl = useIntl();
  const theme = useTheme();
  const isDarkTheme = theme === "dark";
  const languageCode = intl.locale === "pt-BR" ? "pt" : "en";

  if (variant === "outline") {
    return (
      <strong
        className={classNames(
          "inline-flex whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-bold leading-4 tracking-wider dark:border-none",
        )}
        style={{
          borderColor: isDarkTheme
            ? tinycolor(indicator.columnTheme.textColor).brighten(50).toRgbString()
            : tinycolor(indicator.columnTheme.textColor).setAlpha(0.25).toRgbString(),
          color: isDarkTheme
            ? tinycolor(indicator.columnTheme.textColor).brighten(50).toRgbString()
            : indicator.columnTheme.textColor,
          backgroundColor: isDarkTheme
            ? tinycolor(indicator.columnTheme.backgroundColor).darken(80).toRgbString()
            : tinycolor(indicator.columnTheme.backgroundColor).setAlpha(0.5).toRgbString(),
        }}
      >
        {translateIndicatorCategory(indicator.category, languageCode)}
      </strong>
    );
  }

  return (
    <strong
      className={classNames(
        "inline-flex whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-bold leading-4 tracking-wider",
      )}
      style={{
        color: isDarkTheme
          ? tinycolor(indicator.columnTheme.textColor).brighten(50).toRgbString()
          : indicator.columnTheme.textColor,
        backgroundColor: isDarkTheme
          ? tinycolor(indicator.columnTheme.backgroundColor).darken(80).toRgbString()
          : indicator.columnTheme.backgroundColor,
      }}
    >
      {translateIndicatorCategory(indicator.category, languageCode)}
    </strong>
  );
}
